const locale = {
	en: {
		'test-string': 'Random locale test',
		'waiting.for.shouts': 'Waiting fot shouts',
		'shouts.not.enabled': 'Shouts not enabled',
		'no.shouts': 'No shouts yet',
		shouts: 'Shouts',
		results: 'Results',
		question: 'Question',
		winners: 'Winners',
		'winners.count': 'Winners count:',
		'prize.per.user': 'Prize per user:',
		'question.not.started': 'Previous question not available',
		'nextquestion.not.started': 'Next question hasn\'t been launched yet',
		'quiz.not.started': 'Quiz hasn\'t been started',
		'total.players': 'Total players',
		'intherunning.players': 'Remaining players',
		'quiz.towin': 'Amount to win',
		'nothing.towin': 'N/A',
		'not.known': 'Unknown',
		'next.stream': 'Next broadcast',
		'timer.seconds.left': 'seconds remaining',
		'calendar.lastDay': 'yesterday',
		'calendar.sameDay': 'today',
		'calendar.nextDay': 'tomorrow',
		'calendar.months': 'January_February_March_April_May_June_July_August_September_October_November_December',
		'calendar.days': 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday',
	},
	nl: {
		'test-string': 'Random locale test',
		'waiting.for.shouts': 'Wachten op berichten',
		'shouts.not.enabled': 'Berichten niet actief',
		'no.shouts': 'Nog geen berichten',
		shouts: 'Berichten',
		results: 'Resultaten',
		question: 'Vraag',
		winners: 'Winnaars',
		'winners.count': 'Aantal winnaars:',
		'prize.per.user': 'Bedrag elk gewonnen:',
		'question.not.started': 'Vorige vraag is nog niet beschikbaar',
		'nextquestion.not.started': 'Volgende vraag nog niet gestart',
		'quiz.not.started': 'Quiz is nog niet gestart',
		'total.players': 'Totaal spelers',
		'intherunning.players': 'Resterende spelers',
		'quiz.towin': 'Te winnen bedrag',
		'nothing.towin': 'N/A',
		'not.known': 'Niet bekend',
		'next.stream': 'Volgende uitzending',
		'timer.seconds.left': 'seconden over',
		'calendar.lastDay': 'gisteren',
		'calendar.sameDay': 'vandaag',
		'calendar.nextDay': 'morgen',
		'calendar.months': 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december',
		'calendar.days': 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag',
	},
};

export default locale;



// WEBPACK FOOTER //
// ./src/locale.js